import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import {
  CustomHeight, FilterHeaderWrapper, FlexCenterWrapper,
  RelativeWrapper, AbsoluteLeftTopWrapper, Mt3, Mr3,
  CustomBorderWrapper, FullWIdthColumnScrollWrapper, Mt10
} from 'wrappers';
import { Icon, SecondaryTextXs300, ClickableIcon } from 'atoms';
import { IconLabel } from 'molecules';
import { DownCaretSvg, CheckboxSvg } from 'components/icons';
import { prioritySettings } from 'utils';

export const definition = {
  name: 'PriorityDropdown',
  controller: Controller,
  initialProps: ({ priority_id, priorities }) => ({ priority_id, priorities }),
  props: internalState,
  elements: [
    {
      wrapper: RelativeWrapper,
      name: 'Wrapper',
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: FilterHeaderWrapper,
          name: 'HeaderWrapper',
          isButton: true,
          bindings: ({ isOpen, containerRef }) => ({ isOpen, containerRef }),
          elements: [
            {
              component: SecondaryTextXs300,
              name: 'Label',
              renderIf: ({ priority_id }) => !priority_id,
              displayValue: ({ }) => 'Select a priority'
            },
            {
              component: IconLabel,
              name: 'Option',
              renderIf: ({ priority_id, priorities }) => priority_id && priorities.find(p => p.id === priority_id),
              bindings: ({ priority_id, priorities, isOpen, containerRef }) => {
                let priority = priorities.find(p => p.id === priority_id);
                return { priority, text: priority?.name?.toUpperCase() ?? '', icon: prioritySettings.icon(priority), isOpen, containerRef }
              },
              displayState: ({ priority_id, priorities }) => {
                let priority = priorities.find(p => p.id === priority_id);
                return {
                  background: prioritySettings[priority?.color]?.background,
                  color: prioritySettings[priority?.color]?.textColor,
                }
              }
            },
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ isOpen }) => DownCaretSvg({ up: isOpen, color: window?.settings?.primary_color ?? '#1DBD6B' })
            }
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          name: 'DropdownWrapper',
          displayState: ({ }) => ({ top: '50px', width: '100%' }),
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({ borderRadius: '8px', border: '1px solid #E3E3E3', background: '#FFFFFF', padding: '16px' }),
              elements: [
                {
                  wrapper: CustomHeight,
                  name: 'ListWrapper',
                  displayState: ({ }) => ({ height: 270, width: '100%' }),
                  elements: [
                    {
                      wrapper: FullWIdthColumnScrollWrapper,
                      name: 'ListWrapper',
                      elements: [
                        {
                          component: SecondaryTextXs300,
                          name: 'High',
                          displayValue: ({ }) => 'HIGH PRIORITY'
                        },
                        {
                          wrapper: wrap(FlexCenterWrapper, Mt3),
                          name: 'HighPriorityWrapper',
                          isListOf: 'priorities',
                          renderIf: ({ priority }) => priority.is_high_priority,
                          elements: [
                            {
                              component: wrap(ClickableIcon, Mr3),
                              name: 'Icon',
                              displayValue: ({ priority, priority_id }) => CheckboxSvg({ round: true, checked: priority.id === priority_id }),
                              bindings: ({ priority_id, priority }) => ({ priority_id, priority })
                            },
                            {
                              component: IconLabel,
                              name: 'Option',
                              bindings: ({ priority }) => {
                                return { priority, text: priority?.name?.toUpperCase() ?? '', icon: prioritySettings.icon(priority) }
                              },
                              displayState: ({ priority }) => {
                                return {
                                  background: prioritySettings[priority?.color]?.background,
                                  color: prioritySettings[priority?.color]?.textColor,
                                }
                              }
                            },
                          ]
                        },
                        {
                          component: wrap(SecondaryTextXs300, Mt10),
                          name: 'Low',
                          displayValue: ({ }) => 'STANDARD PRIORITY'
                        },
                        {
                          wrapper: wrap(FlexCenterWrapper, Mt3),
                          name: 'LowPriorityWrapper',
                          isListOf: 'priorities',
                          renderIf: ({ priority }) => !priority.is_high_priority,
                          elements: [
                            {
                              component: wrap(ClickableIcon, Mr3),
                              name: 'Icon',
                              displayValue: ({ priority, priority_id }) => CheckboxSvg({ round: true, checked: priority.id === priority_id }),
                              bindings: ({ priority_id, priority }) => ({ priority_id, priority })
                            },
                            {
                              component: IconLabel,
                              name: 'Option',
                              bindings: ({ priority }) => {
                                return { priority, text: priority?.name?.toUpperCase() ?? '', icon: prioritySettings.icon(priority) }
                              },
                              displayState: ({ priority }) => {
                                return {
                                  background: prioritySettings[priority?.color]?.background,
                                  color: prioritySettings[priority?.color]?.textColor,
                                }
                              }
                            },
                          ]
                        }
                      ]
                    },
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);
